export const mapInstockProducts = (products, prices = {}, transformProduct = product => product, isBot) => {
    const oosSKUs = [];
    let hasAccoryCategory = false;
    const categoryMap = {};
    const inStockSKUs = products.reduce((r, p, i) => {
        const price = prices[p.sku];
        const productData = transformProduct(p, prices[p.sku]);
        if (!hasAccoryCategory && p?.accessoryCategory) {
            hasAccoryCategory = true;
        }

        // For bots, include all products regardless of price/stock status
        if (isBot) {
            r.push(productData);
        } else if (price && price.isOOS) {
            oosSKUs.push(productData);
        } else if (hasAccoryCategory && price) {
            //if product has accessory category only include one in stock product of each category
            if (!categoryMap[p.accessoryCategory]) {
                categoryMap[p.accessoryCategory] = true;
                r.push(productData);
            }
        } else if (price) {
            r.push(productData);
        }
        return r;
    }, []);
    //if there are NO in stock options just include the OOS products
    if (inStockSKUs.length < 1) {
        return inStockSKUs.concat(oosSKUs);
    }
    return inStockSKUs;
};
